/* eslint-disable no-unused-vars */

function transformArrayDynamic(arr) {
  const result = {};

  arr.forEach((item) => {
    const key = item.name;
    const translations = {};

    function collectTranslations(languageData) {
      Object.keys(languageData).forEach((langKey) => {
        if (langKey.includes("-")) {
          const languageCode = langKey.split("-")[0].toLowerCase();
          translations[languageCode] = languageData[langKey][0].name;
          if (languageData[langKey][0]) {
            const nestedLanguages = languageData[langKey][0];
            collectTranslations(nestedLanguages);
          }
        }
      });
    }

    collectTranslations(item);

    // Add the collected translations to the result object
    result[key] = translations;
  });

  return result;
}
export const appTranslation = async () => {
  try {
    const translationUrl = "https://resources.wizztech.us/static/esyncing.json";
    if (translationUrl) {
      const data1 = await fetch(translationUrl);
      const data2 = await data1.json();
      const formattedData = transformArrayDynamic(data2["translate-key"]);
      // console.log("formatedData",formattedData);
      return formattedData;
    } else {
      console.warn(`No translation URL found for domain: ${translationUrl}`);
    }
  } catch (error) {
    console.error("Error in appTranslation:", error);
  }
};
